import parsePhoneNumber from 'libphonenumber-js';

const cpfBlackList = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
    '12345678909'
];

const cpfVerifierDigit = (digits: string) => {
    const numbers: Array<number> = digits
        .split('')
        .map(number => parseInt(number, 10))

    const modulus: number = numbers.length + 1;

    const multiplied: Array<number> = numbers.map((number, index) => number * (modulus - index));

    const mod: number = multiplied.reduce((buffer, number) => buffer + number) % 11;

    return (mod < 2 ? 0 : 11 - mod);
};

const isValidCPF = (number: string) => {
    if (!number)
        return false;

    const stripped = number.replace(/[.-]/g, '');

    if (!stripped || stripped.length !== 11 || cpfBlackList.includes(stripped))
        return false;

    let numbers = stripped.substring(0, 9);

    numbers += cpfVerifierDigit(numbers);

    numbers += cpfVerifierDigit(numbers);

    return numbers.slice(-2) === stripped.slice(-2);
};

const cnpjBlackList = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999'
];

const cnpjVerifierDigit = (digits: string) => {
    let index = 2;

    const reverse = digits.split('').reduce<number[]>((buffer, number) => [parseInt(number, 10), ...buffer], []);

    const sum: number = reverse.reduce((buffer, number) => {
        buffer += number * index;

        index = (index === 9 ? 2 : index + 1);

        return buffer;
    }, 0);

    const mod: number = sum % 11;

    return (mod < 2 ? 0 : 11 - mod);
}

const isValidCNPJ = (number: string): boolean => {
    const stripped: string = number.replace(/[-\\/.]/g, '');

    if (!stripped || stripped.length !== 14 || cnpjBlackList.includes(stripped))
        return false;

    let numbers: string = stripped.substring(0, 12);

    numbers += cnpjVerifierDigit(numbers);

    numbers += cnpjVerifierDigit(numbers);

    return numbers.slice(-2) === stripped.slice(-2);
};

const isValidPhone = (value: any) => {
    if (typeof value !== 'string')
        return false;

    const phone = parsePhoneNumber(value, 'BR');

    if (!phone?.isPossible())
        return false;

    if (phone.country === 'BR')
        // O `nationalNumber` já é o número com apenas os dígitos e sem o código do país (+55, por exemplo)
        // 2 dígitos para o código de área + 8 ou 9 dígitos para o telefone = 10 ou 11 dígitos
        return phone.nationalNumber.length === 10 || phone.nationalNumber.length === 11;

    return true;
};

const validator = { isValidCPF, isValidCNPJ, isValidPhone };

export default validator;
